import { fetchProfile } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    profileData: {},
    hasError: {},
  },

  mutations: {
    SET_PROFILE_DATA(state, payload) {
      state.profileData = payload;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadProfileData({ commit } = {}) {
      // if (state.isLoaded) return;
      try {
        const response = await fetchProfile();
        commit("SET_PROFILE_DATA", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
  },

  getters: {
    user: (state) =>
      Array.isArray(state.profileData)
        ? state.profileData[0]
        : state.profileData,
  },
};
